export const ESC = 27
export const SPACE = 32

export const KEY_Z = 90
export const KEY_X = 88
export const KEY_C = 67

export const KEY_N = 78
export const KEY_B = 66
export const KEY_M = 77

export const KEY_Q = 81
export const KEY_W = 87
export const KEY_E = 69

export const KEY_T = 84
export const KEY_Y = 89
export const KEY_U = 85

export const KEY_L = 76
export const KEY_Ö = 186
export const KEY_Ä = 222

export const KEY_0 = 48
export const KEY_1 = 49
export const KEY_2 = 50
export const KEY_3 = 51
export const KEY_4 = 52
export const KEY_5 = 53
export const KEY_6 = 54
export const KEY_7 = 55
export const KEY_8 = 56
export const KEY_9 = 57
